var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMusclesBackLayer1Drawio(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      background: "transparent",
      backgroundColor: "transparent",
      colorScheme: "light dark"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "665px",
    height: "883px",
    viewBox: "0 0 665 883",
    content: "<mxfile host=\"app.diagrams.net\" agent=\"Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/18.6 Safari/605.1.15\" version=\"28.2.7\"> <diagram name=\"Page-1\" id=\"Daq3IqBI-Rq7VqvxsHLT\"> <mxGraphModel dx=\"1193\" dy=\"819\" grid=\"1\" gridSize=\"10\" guides=\"1\" tooltips=\"1\" connect=\"1\" arrows=\"1\" fold=\"1\" page=\"1\" pageScale=\"1\" pageWidth=\"827\" pageHeight=\"1169\" math=\"0\" shadow=\"0\"> <root> <mxCell id=\"0\" /> <mxCell id=\"1\" parent=\"0\" /> <object label=\"\" class=\"latissimus dorsi\" id=\"Dl_1z7jB40fjsSEJNZoi-3\"> <mxCell style=\"ellipse;whiteSpace=wrap;html=1;rotation=-60;flipH=1;class=latissimus dorsi;\" vertex=\"1\" parent=\"1\"> <mxGeometry x=\"420\" y=\"360\" width=\"157.25\" height=\"70\" as=\"geometry\" /> </mxCell> </object> <object label=\"\" class=\"back quads\" id=\"Dl_1z7jB40fjsSEJNZoi-10\"> <mxCell style=\"ellipse;whiteSpace=wrap;html=1;rotation=-3;flipH=1;class=back quads;\" vertex=\"1\" parent=\"1\"> <mxGeometry x=\"276\" y=\"670\" width=\"75.35\" height=\"130\" as=\"geometry\" /> </mxCell> </object> <object label=\"\" class=\"calves\" id=\"Dl_1z7jB40fjsSEJNZoi-11\"> <mxCell style=\"ellipse;whiteSpace=wrap;html=1;rotation=-8;flipH=1;class=calves;\" vertex=\"1\" parent=\"1\"> <mxGeometry x=\"514.67\" y=\"790\" width=\"50.17\" height=\"205.99\" as=\"geometry\" /> </mxCell> </object> <object label=\"\" class=\"forearm\" id=\"Dl_1z7jB40fjsSEJNZoi-12\"> <mxCell style=\"ellipse;whiteSpace=wrap;html=1;rotation=11;flipH=1;class=forearm;\" vertex=\"1\" parent=\"1\"> <mxGeometry x=\"80\" y=\"120\" width=\"34.49\" height=\"130\" as=\"geometry\" /> </mxCell> </object> <object label=\"\" class=\"calves\" id=\"Dl_1z7jB40fjsSEJNZoi-13\"> <mxCell style=\"ellipse;whiteSpace=wrap;html=1;rotation=10;flipH=1;class=calves;\" vertex=\"1\" parent=\"1\"> <mxGeometry x=\"312.5900080377642\" y=\"789.9988169776213\" width=\"50.17\" height=\"205.99\" as=\"geometry\" /> </mxCell> </object> <object label=\"\" class=\"triceps\" id=\"Dl_1z7jB40fjsSEJNZoi-16\"> <mxCell style=\"ellipse;whiteSpace=wrap;html=1;rotation=90;flipH=1;class=triceps;\" vertex=\"1\" parent=\"1\"> <mxGeometry x=\"596.5\" y=\"217.5\" width=\"69.94\" height=\"135\" as=\"geometry\" /> </mxCell> </object> <object label=\"\" class=\"forearm\" id=\"Dl_1z7jB40fjsSEJNZoi-17\"> <mxCell style=\"ellipse;whiteSpace=wrap;html=1;rotation=-195;flipH=1;class=forearm;\" vertex=\"1\" parent=\"1\"> <mxGeometry x=\"679.9957454780304\" y=\"129.99626804936668\" width=\"34.49\" height=\"130\" as=\"geometry\" /> </mxCell> </object> <object label=\"\" class=\"back quads\" id=\"Dl_1z7jB40fjsSEJNZoi-18\"> <mxCell style=\"ellipse;whiteSpace=wrap;html=1;rotation=-15;flipH=1;class=back quads;\" vertex=\"1\" parent=\"1\"> <mxGeometry x=\"441.93020487766995\" y=\"660.0026769105002\" width=\"75.35\" height=\"130\" as=\"geometry\" /> </mxCell> </object> <object label=\"\" class=\"latissimus dorsi\" id=\"Dl_1z7jB40fjsSEJNZoi-22\"> <mxCell style=\"ellipse;whiteSpace=wrap;html=1;rotation=67;flipH=1;class=latissimus dorsi;\" vertex=\"1\" parent=\"1\"> <mxGeometry x=\"213.93838913245537\" y=\"360.00124737255146\" width=\"157.25\" height=\"70\" as=\"geometry\" /> </mxCell> </object> <object label=\"\" class=\"triceps\" id=\"Dl_1z7jB40fjsSEJNZoi-23\"> <mxCell style=\"ellipse;whiteSpace=wrap;html=1;rotation=90;flipH=1;class=triceps;\" vertex=\"1\" parent=\"1\"> <mxGeometry x=\"140.99999999999997\" y=\"217.50000000000003\" width=\"69.94\" height=\"135\" as=\"geometry\" /> </mxCell> </object> <object label=\"\" class=\"glutes\" id=\"Dl_1z7jB40fjsSEJNZoi-24\"> <mxCell style=\"ellipse;whiteSpace=wrap;html=1;rotation=-9;flipH=1;class=glutes;\" vertex=\"1\" parent=\"1\"> <mxGeometry x=\"399\" y=\"527\" width=\"101\" height=\"130\" as=\"geometry\" /> </mxCell> </object> <object label=\"\" class=\"glutes\" id=\"Dl_1z7jB40fjsSEJNZoi-26\"> <mxCell style=\"ellipse;whiteSpace=wrap;html=1;rotation=7;flipH=1;class=glutes;\" vertex=\"1\" parent=\"1\"> <mxGeometry x=\"288\" y=\"534\" width=\"101\" height=\"130\" as=\"geometry\" /> </mxCell> </object> <object label=\"\" class=\"rhomboids\" id=\"Dl_1z7jB40fjsSEJNZoi-29\"> <mxCell style=\"ellipse;whiteSpace=wrap;html=1;rotation=90;flipH=1;class=rhomboids;\" vertex=\"1\" parent=\"1\"> <mxGeometry x=\"282\" y=\"307\" width=\"157.25\" height=\"70\" as=\"geometry\" /> </mxCell> </object> <object label=\"\" class=\"rhomboids\" id=\"Dl_1z7jB40fjsSEJNZoi-30\"> <mxCell style=\"ellipse;whiteSpace=wrap;html=1;rotation=90;flipH=1;class=rhomboids;\" vertex=\"1\" parent=\"1\"> <mxGeometry x=\"352.35\" y=\"305\" width=\"157.25\" height=\"70.01\" as=\"geometry\" /> </mxCell> </object> <object label=\"\" class=\"trapezius\" id=\"Dl_1z7jB40fjsSEJNZoi-31\"> <mxCell style=\"ellipse;whiteSpace=wrap;html=1;rotation=-240;flipH=1;class=trapezius;\" vertex=\"1\" parent=\"1\"> <mxGeometry x=\"288\" y=\"217.5\" width=\"114.13\" height=\"34.13\" as=\"geometry\" /> </mxCell> </object> <object label=\"\" class=\"rotator cuff\" id=\"Dl_1z7jB40fjsSEJNZoi-35\"> <mxCell style=\"ellipse;whiteSpace=wrap;html=1;rotation=-195;flipH=1;class=side;class=rotator cuff;\" vertex=\"1\" parent=\"1\"> <mxGeometry x=\"235.33363252174442\" y=\"235.9986325217444\" width=\"83.26\" height=\"34.13\" as=\"geometry\" /> </mxCell> </object> <object label=\"\" class=\"trapezius\" id=\"Dl_1z7jB40fjsSEJNZoi-36\"> <mxCell style=\"ellipse;whiteSpace=wrap;html=1;rotation=-117;flipH=1;class=trapezius;\" vertex=\"1\" parent=\"1\"> <mxGeometry x=\"394.9962235155815\" y=\"215.86723966695897\" width=\"114.13\" height=\"34.13\" as=\"geometry\" /> </mxCell> </object> <object label=\"\" class=\"rotator cuff\" id=\"Dl_1z7jB40fjsSEJNZoi-37\"> <mxCell style=\"ellipse;whiteSpace=wrap;html=1;rotation=-170;flipH=1;class=side;class=rotator cuff;\" vertex=\"1\" parent=\"1\"> <mxGeometry x=\"482.5782391530885\" y=\"240.00316107324085\" width=\"83.26\" height=\"34.13\" as=\"geometry\" /> </mxCell> </object> </root> </mxGraphModel> </diagram>\n</mxfile>\n",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    "data-cell-id": 0
  }, /*#__PURE__*/React.createElement("g", {
    "data-cell-id": 1
  }, /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Dl_1z7jB40fjsSEJNZoi-3"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5,0.5)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 430.63,
    cy: 277,
    rx: 78.625,
    ry: 35,
    fill: "#ffffff",
    stroke: "#000000",
    transform: "translate(430.63,0)scale(-1,1)translate(-430.63,0)rotate(60,430.63,277)",
    pointerEvents: "all",
    style: {
      fill: "light-dark(#ffffff, var(--ge-dark-color, #121212))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Dl_1z7jB40fjsSEJNZoi-10"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5,0.5)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 245.67,
    cy: 617,
    rx: 37.675,
    ry: 65,
    fill: "#ffffff",
    stroke: "#000000",
    transform: "translate(245.67,0)scale(-1,1)translate(-245.67,0)rotate(3,245.67,617)",
    pointerEvents: "all",
    style: {
      fill: "light-dark(#ffffff, var(--ge-dark-color, #121212))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Dl_1z7jB40fjsSEJNZoi-11"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5,0.5)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 471.76,
    cy: 774.99,
    rx: 25.085,
    ry: 102.995,
    fill: "#ffffff",
    stroke: "#000000",
    transform: "translate(471.76,0)scale(-1,1)translate(-471.76,0)rotate(8,471.76,774.99)",
    pointerEvents: "all",
    style: {
      fill: "light-dark(#ffffff, var(--ge-dark-color, #121212))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Dl_1z7jB40fjsSEJNZoi-12"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5,0.5)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.24,
    cy: 67,
    rx: 17.245,
    ry: 65,
    fill: "#ffffff",
    stroke: "#000000",
    transform: "translate(29.24,0)scale(-1,1)translate(-29.24,0)rotate(-11,29.24,67)",
    pointerEvents: "all",
    style: {
      fill: "light-dark(#ffffff, var(--ge-dark-color, #121212))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Dl_1z7jB40fjsSEJNZoi-13"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5,0.5)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 269.68,
    cy: 774.99,
    rx: 25.085,
    ry: 102.995,
    fill: "#ffffff",
    stroke: "#000000",
    transform: "translate(269.68,0)scale(-1,1)translate(-269.68,0)rotate(-10,269.68,774.99)",
    pointerEvents: "all",
    style: {
      fill: "light-dark(#ffffff, var(--ge-dark-color, #121212))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Dl_1z7jB40fjsSEJNZoi-16"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5,0.5)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 563.47,
    cy: 167,
    rx: 34.97,
    ry: 67.5,
    fill: "#ffffff",
    stroke: "#000000",
    transform: "translate(563.47,0)scale(-1,1)translate(-563.47,0)rotate(-90,563.47,167)",
    pointerEvents: "all",
    style: {
      fill: "light-dark(#ffffff, var(--ge-dark-color, #121212))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Dl_1z7jB40fjsSEJNZoi-17"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5,0.5)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 629.24,
    cy: 77,
    rx: 17.245,
    ry: 65,
    fill: "#ffffff",
    stroke: "#000000",
    transform: "translate(629.24,0)scale(-1,1)translate(-629.24,0)rotate(195,629.24,77)",
    pointerEvents: "all",
    style: {
      fill: "light-dark(#ffffff, var(--ge-dark-color, #121212))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Dl_1z7jB40fjsSEJNZoi-18"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5,0.5)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 411.61,
    cy: 607,
    rx: 37.675,
    ry: 65,
    fill: "#ffffff",
    stroke: "#000000",
    transform: "translate(411.61,0)scale(-1,1)translate(-411.61,0)rotate(15,411.61,607)",
    pointerEvents: "all",
    style: {
      fill: "light-dark(#ffffff, var(--ge-dark-color, #121212))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Dl_1z7jB40fjsSEJNZoi-22"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5,0.5)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 224.56,
    cy: 277,
    rx: 78.625,
    ry: 35,
    fill: "#ffffff",
    stroke: "#000000",
    transform: "translate(224.56,0)scale(-1,1)translate(-224.56,0)rotate(-67,224.56,277)",
    pointerEvents: "all",
    style: {
      fill: "light-dark(#ffffff, var(--ge-dark-color, #121212))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Dl_1z7jB40fjsSEJNZoi-23"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5,0.5)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 107.97,
    cy: 167,
    rx: 34.97,
    ry: 67.5,
    fill: "#ffffff",
    stroke: "#000000",
    transform: "translate(107.97,0)scale(-1,1)translate(-107.97,0)rotate(-90,107.97,167)",
    pointerEvents: "all",
    style: {
      fill: "light-dark(#ffffff, var(--ge-dark-color, #121212))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Dl_1z7jB40fjsSEJNZoi-24"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5,0.5)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 381.5,
    cy: 474,
    rx: 50.5,
    ry: 65,
    fill: "#ffffff",
    stroke: "#000000",
    transform: "translate(381.5,0)scale(-1,1)translate(-381.5,0)rotate(9,381.5,474)",
    pointerEvents: "all",
    style: {
      fill: "light-dark(#ffffff, var(--ge-dark-color, #121212))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Dl_1z7jB40fjsSEJNZoi-26"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5,0.5)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 270.5,
    cy: 481,
    rx: 50.5,
    ry: 65,
    fill: "#ffffff",
    stroke: "#000000",
    transform: "translate(270.5,0)scale(-1,1)translate(-270.5,0)rotate(-7,270.5,481)",
    pointerEvents: "all",
    style: {
      fill: "light-dark(#ffffff, var(--ge-dark-color, #121212))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Dl_1z7jB40fjsSEJNZoi-29"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5,0.5)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 292.63,
    cy: 224,
    rx: 78.625,
    ry: 35,
    fill: "#ffffff",
    stroke: "#000000",
    transform: "translate(292.63,0)scale(-1,1)translate(-292.63,0)rotate(-90,292.63,224)",
    pointerEvents: "all",
    style: {
      fill: "light-dark(#ffffff, var(--ge-dark-color, #121212))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Dl_1z7jB40fjsSEJNZoi-30"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5,0.5)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 362.97,
    cy: 222.01,
    rx: 78.625,
    ry: 35.005,
    fill: "#ffffff",
    stroke: "#000000",
    transform: "translate(362.97,0)scale(-1,1)translate(-362.97,0)rotate(-90,362.97,222.01)",
    pointerEvents: "all",
    style: {
      fill: "light-dark(#ffffff, var(--ge-dark-color, #121212))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Dl_1z7jB40fjsSEJNZoi-31"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5,0.5)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 277.07,
    cy: 116.57,
    rx: 57.065,
    ry: 17.065,
    fill: "#ffffff",
    stroke: "#000000",
    transform: "translate(277.07,0)scale(-1,1)translate(-277.07,0)rotate(240,277.07,116.57)",
    pointerEvents: "all",
    style: {
      fill: "light-dark(#ffffff, var(--ge-dark-color, #121212))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Dl_1z7jB40fjsSEJNZoi-35"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5,0.5)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 208.96,
    cy: 135.06,
    rx: 41.63,
    ry: 17.065,
    fill: "#ffffff",
    stroke: "#000000",
    transform: "translate(208.96,0)scale(-1,1)translate(-208.96,0)rotate(195,208.96,135.06)",
    pointerEvents: "all",
    style: {
      fill: "light-dark(#ffffff, var(--ge-dark-color, #121212))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Dl_1z7jB40fjsSEJNZoi-36"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5,0.5)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 384.06,
    cy: 114.93,
    rx: 57.065,
    ry: 17.065,
    fill: "#ffffff",
    stroke: "#000000",
    transform: "translate(384.06,0)scale(-1,1)translate(-384.06,0)rotate(117,384.06,114.93)",
    pointerEvents: "all",
    style: {
      fill: "light-dark(#ffffff, var(--ge-dark-color, #121212))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Dl_1z7jB40fjsSEJNZoi-37"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5,0.5)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 456.21,
    cy: 139.07,
    rx: 41.63,
    ry: 17.065,
    fill: "#ffffff",
    stroke: "#000000",
    transform: "translate(456.21,0)scale(-1,1)translate(-456.21,0)rotate(170,456.21,139.07)",
    pointerEvents: "all",
    style: {
      fill: "light-dark(#ffffff, var(--ge-dark-color, #121212))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusclesBackLayer1Drawio);
export default __webpack_public_path__ + "static/media/muscles_back_layer_1.drawio.e2058d9f646055ed945d3456630361d4.svg";
export { ForwardRef as ReactComponent };